import { Redirect } from 'react-router-dom'

// validation logic pending
const LoginValidation = ({ children }) => {
  const isLoggedIn = sessionStorage.getItem('token')
  return (
    <>
      {isLoggedIn ? (
        <>
          <div className="navbar"></div>
          {children}
        </>
      ) : (
        <Redirect to="/signin" />
      )}
    </>
  )
}
export default LoginValidation
